// Button identifiers
export const BUTTON_TYPES = {
  SEND_CONFIRMATION_LINK: 'send_confirmation_link',
  ADD_CUSTOMER_NEEDS: 'add_customer_needs',
  EDIT_CUSTOMER_NEEDS: 'edit_customer_needs',
  RESCHEDULE_TRIAL: 'reschedule_trial',
  RESCHEDULE_TRIAL_SAME_TUTOR: 'reschedule_trial_same_tutor',
  RESCHEDULE_TRIAL_DIFFERENT_TUTOR: 'reschedule_trial_different_tutor',
  EDIT_LEAD_DETAILS: 'edit_lead_details',
  CANCEL_TRIAL: 'cancel_trial',
  ASSIGN_SLOTS: 'assign_slots',
};

// Status values
export const STATUS_TYPES = {
  QUALIFIED_LEAD: 'Qualified Lead',
  TRANSFER_REQUESTED: 'Transfer Requested',
  TRIAL_REQUESTED: 'Trial Requested',
  TRIAL_CONFIRMED: 'Trial Confirmed',
  TUTOR_ASSIGNED: 'Tutor Assigned',
  TRIAL_DONE: 'Trial Done',
  TRIAL_CANCELLED: 'Trial Cancelled',
};

// Configuration: Status -> Allowed Buttons
export const BUTTON_CONFIG = {
  [STATUS_TYPES.QUALIFIED_LEAD]: [
    BUTTON_TYPES.ADD_CUSTOMER_NEEDS,
    BUTTON_TYPES.EDIT_CUSTOMER_NEEDS,
    BUTTON_TYPES.ASSIGN_SLOTS,
    BUTTON_TYPES.EDIT_LEAD_DETAILS,
  ],
  [STATUS_TYPES.TRANSFER_REQUESTED]: [
    BUTTON_TYPES.ADD_CUSTOMER_NEEDS,
    BUTTON_TYPES.EDIT_CUSTOMER_NEEDS,
    BUTTON_TYPES.ASSIGN_SLOTS,
    BUTTON_TYPES.EDIT_LEAD_DETAILS,
  ],
  [STATUS_TYPES.TRIAL_REQUESTED]: [
    BUTTON_TYPES.SEND_CONFIRMATION_LINK,
    BUTTON_TYPES.ADD_CUSTOMER_NEEDS,
    BUTTON_TYPES.EDIT_CUSTOMER_NEEDS,
    BUTTON_TYPES.EDIT_LEAD_DETAILS,
    BUTTON_TYPES.RESCHEDULE_TRIAL,
    BUTTON_TYPES.CANCEL_TRIAL,
  ],

  [STATUS_TYPES.TRIAL_CONFIRMED]: [
    BUTTON_TYPES.ADD_CUSTOMER_NEEDS,
    BUTTON_TYPES.EDIT_CUSTOMER_NEEDS,
    BUTTON_TYPES.CANCEL_TRIAL,
    BUTTON_TYPES.RESCHEDULE_TRIAL_DIFFERENT_TUTOR,
  ],

  [STATUS_TYPES.TUTOR_ASSIGNED]: [
    BUTTON_TYPES.CANCEL_TRIAL,
    BUTTON_TYPES.RESCHEDULE_TRIAL_SAME_TUTOR,
  ],

  [STATUS_TYPES.TRIAL_DONE]: [
    BUTTON_TYPES.EDIT_LEAD_DETAILS,
    BUTTON_TYPES.EDIT_CUSTOMER_NEEDS,
    BUTTON_TYPES.RESCHEDULE_TRIAL_SAME_TUTOR,
    BUTTON_TYPES.RESCHEDULE_TRIAL_DIFFERENT_TUTOR,
  ],

  [STATUS_TYPES.TRIAL_CANCELLED]: [
    BUTTON_TYPES.EDIT_LEAD_DETAILS,
    BUTTON_TYPES.ADD_CUSTOMER_NEEDS,
    BUTTON_TYPES.EDIT_CUSTOMER_NEEDS,
    BUTTON_TYPES.RESCHEDULE_TRIAL,
    BUTTON_TYPES.RESCHEDULE_TRIAL_DIFFERENT_TUTOR,
  ],
};
